// extracted by mini-css-extract-plugin
export default {"breakpoints_counter":"BreakpointsCounter_breakpoints_counter__z3mmL"};